import apiClient from "@/api/apiClient";

export const getReports = async (filters) => {
  const result = await apiClient.get("/api/reports", {
    params: filters,
  });
  return result.data;
};
